import { FC } from 'react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import VideoCarousel from 'components/VideoCarousel/VideoCarousel';
import FullTeaser from 'components/FullTeaser/FullTeaser';
import { LeftArrow, RightArrow } from 'components/Slider/arrows';
import { YoutubePlaylistVideo } from 'utils/getYoutubePlaylistVideos';
import GetReadyToVote from './GetReadyToVote';
import DonationSection from './DonationSection';
import VoterGuideBanner from './VoterGuideBanner';
import { GetReadyToVoteItem } from './utils/getReadyToVoteBoxes';
import LiveVideoSection from 'components/LiveVideoSection/LiveVideoSection';
import '/public/css/components/scrollmenu.css';
import '/public/css/pages/electionHub.css';
import '/public/css/pages/electionHub2026.css';
import LandingHeading from '../../components/ElectionHubHeader/LandingHeading';
import Link from 'next/link';

interface ElectionHub2026Props {
  data: any;
  videos: YoutubePlaylistVideo[];
  getReadyToVoteItems: GetReadyToVoteItem[];
  membershipMessage?: GetReadyToVoteItem | null;
  liveVideoId?: string | null;
  electionCoverage?: any;
  politicsFriday?: any;
}

const CollectionCarousel: FC<{ collection?: any }> = ({ collection }) => {
  const items = collection?.collection?.results?.items;

  if (!items?.length) {
    return null;
  }

  return (
    <section className="election-hub-2026-collection">
      <h2 className="election-hub-2026-hdg-block">
        {collection.collection.title}
        <span className="viewAll">
          <Link href={`/${collection.collection.canonicalSlug}`} passHref>
            View All{' '}
            <span className="srOnly">- {collection.collection.title}</span>
          </Link>
        </span>
      </h2>

      <div className="election-hub-scroll-wrapper">
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
          {items.slice(0, 6).map((item: any, idx: number) => (
            <FullTeaser
              key={item.id + idx}
              item={item}
              headingLvl={3}
              hideAddFavorites={true}
              condensedBtns={true}
            />
          ))}
        </ScrollMenu>
      </div>
    </section>
  );
};

const ElectionHub2026: FC<ElectionHub2026Props> = ({
  data,
  videos,
  getReadyToVoteItems,
  membershipMessage,
  liveVideoId,
  electionCoverage,
  politicsFriday,
}) => {
  return (
    <>
      <LandingHeading data={data} />
      <div className="election-hub-2026">
        {liveVideoId && <LiveVideoSection videoId={liveVideoId} />}
        <p></p>
        <div className="container">
          <GetReadyToVote items={getReadyToVoteItems} />
        </div>
        <div className="container">
          <DonationSection membershipMessage={membershipMessage} />
        </div>
        <div className="container">
          <CollectionCarousel collection={electionCoverage} />
        </div>
        <section className="election-hub-2026-videos">
          <div className="container">
            <VideoCarousel title="Election Videos" videos={videos} />
          </div>
        </section>

        <div className="container">
          <CollectionCarousel collection={politicsFriday} />
        </div>
      </div>
    </>
  );
};

export default ElectionHub2026;
